import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

//datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";

//ckeditor
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";

//utils
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";
import {
  separateRoles,
  cleanUsers,
  uniqueUsers,
  buildInvestigatorProject,
} from "../../../../utils/auxiliar/manageProject";

//middleware
import moment from "moment";
import produce from "immer";
import Swal from "sweetalert2";
import Axios from "axios";
import { validate } from "./validations";
import { ROUTES } from "../../../../utils/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { useSelector } from "react-redux"
registerLocale("es", es);

  export const ManageProject = () => {
    let {  isAdmin, userRoleId } = useSelector(({ user }) => user);
    const {
      PROJECTS,
      INVESTIGATORS,
      investigatorPROJECT,
      AMBITOS,     
      ENTIDAD_PARTICIPANTE,
      FINANCIADORAS,
      PROPUESTAS,
      CONVOCATORIAS
    } = paths;
    const { id } = useParams();
    const history = useHistory();
    const { deleteIt } = useDelete();

    const [isCreate, setIsCreate] = useState(false);
    const [propuestas, setPropuestas] = useState([])
    const [chosenPropuestaId, setChosenPropuestaId] = useState('')
    const [convocatorias, setConvocatorias] = useState([])
    const [chosenConvocatoriaId, setChosenConvocatoriaId] = useState('')

    //userForm
    const [tituloEs, setTituloEs] = useState("");
    const [tituloEn, setTituloEn] = useState("");
    const [tituloVa, setTituloVa] = useState("");
    const [resumenEs, setResumenEs] = useState("");
    const [resumenEn, setResumenEn] = useState("");
    const [resumenVa, setResumenVa] = useState("");
    const [investigadorParticipanteExterno, setInvestigadorParticipanteExterno] =
      useState("");
    const [acronimo, setAcronimo] = useState("");
    const [referenciaInterna, setReferenciaInterna] = useState('')
    const [referenciaOficial, setReferenciaOficial] = useState('')
    const [mostrarWeb, setMostrarWeb] = useState('')
    const [estado, setEstado] = useState("");
    const [gestionadoPor, setGestionadoPor] = useState("");
    const [tipo, setTipo] = useState("");
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaProrroga, setFechaProrroga] = useState(new Date());
    const [ips, setIps] = useState([]);
    const [chosenIps, setChosenIps] = useState([]);
    const [participants, setParticipants] = useState([]);
    const [chosenParticipants, setChosenParticipants] = useState([]);
    const [ambitos, setAmbitos] = useState([]);
    const [chosenAmbitos, setChosenAmbitos] = useState([]);
    const [entidadesParticipantes, setEntidadesParticipantes] = useState([]);
    const [chosenEntidadesParticipantes, setChosenEntidadesParticipantes] =
      useState([]);
    const [financiadora, setFinanciadora] = useState([]);
    const [chosenFinanciadoraId, setChosenFinanciadoraId] = useState([]);
    const [observaciones, setObservaciones] = useState("");   

  
    const [logo, setLogo] = useState();
    const [message, setMessage] = useState("");

 
    const [produccionPersonal, setProduccionPersonal] = useState("");   
    const [selected, setSelected] = useState("")
    const [allowedEdit, setAllowedEdit] = useState(false);

    const isMounted = useRef(false);
    const source = Axios.CancelToken.source();

    useEffect(() => {
      isMounted.current = true;
      const { pathname } = history.location;
      pathname.includes("crear") ? loadDefaultData() : loadEditData();
      return () => {
        isMounted.current = false;
        source.cancel();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadDefaultData = async () => {
      try {
        let investigators = await getAll(INVESTIGATORS, source);
        // let programs = await getAll(PROGRAMS, source);
        let propuestas = await getAll(PROPUESTAS, source)
        let convocatorias = await getAll(CONVOCATORIAS, source)
        let ambitos = await getAll(AMBITOS, source);
        let financiadoras = await getAll(FINANCIADORAS, source);
        let entidadesParticipantes = await getAll(ENTIDAD_PARTICIPANTE, source);
        if (isMounted.current) {
          setIsCreate(true);
          setAllowedEdit(true);
          setTimeout(() => filterAdmins(investigators), 250);
          // setPrograms(programs);
          setPropuestas(propuestas)
          setConvocatorias(convocatorias)
          setAmbitos(ambitos);
          setFinanciadora(financiadora);
          setEntidadesParticipantes(entidadesParticipantes);
        }
      } catch (error) {
        console.log("HTTP call cancelled");
      }
    };

    const filterAdmins = (investigators) => {
      let newinvestigators = investigators.filter(
        (u) =>
          u.email !== "admin@admin.com" &&
          u.email !== "sombradoble@sombradoble.es"
      );
      setIps(newinvestigators);
      setParticipants(newinvestigators);
    };

    const loadEditData = async () => {
      try {
        let response = await getById(PROJECTS, id, source);
        isMounted.current && buildObjToLoad(response);
      } catch (error) {
        console.log("HTTP call cancelled");
      }
    };

    const buildObjToLoad = async (p) => {
      // let allPrograms = await getAll(PROGRAMS, source);
      let allPropuestas = await getAll(PROPUESTAS, source)
      let allConvocatorias = await getAll(CONVOCATORIAS, source)
      let allAmbitos = await getAll(AMBITOS, source);
       let allFinanciadoras = await getAll(FINANCIADORAS, source);
      let allEntidadesParticipantes = await getAll(ENTIDAD_PARTICIPANTE, source);

      const startDateWithOffset = new Date(p.fechaInicio);
      const startDateNoOffset = new Date(
        startDateWithOffset.getTime() -
          startDateWithOffset.getTimezoneOffset() * -60000
      );
      const endDateWithOffset = new Date(p.fechaProrroga);
      const endDateNoOffset = new Date(
        endDateWithOffset.getTime() -
          endDateWithOffset.getTimezoneOffset() * -60000
      );

      setTituloEn(p.tituloEn);
      setTituloEs(p.tituloEs);
      setTituloVa(p.tituloVa);
      setResumenEn(p.resumenEn);
      setResumenEs(p.resumenEs);
      setResumenVa(p.resumenVa);
      setObservaciones(p.observaciones);    
      setInvestigadorParticipanteExterno(p.investigadorParticipanteExterno);
      setAcronimo(p.acronimo);
      setMostrarWeb(p.mostrarWeb)
      setEstado(p.estado)
      setGestionadoPor(p.gestionadoPor)
      setTipo(p.tipo)
      setReferenciaInterna(p.referenciaInterna)
      setReferenciaOficial(p.referenciaOficial)
     
     
      setProduccionPersonal(p.produccionPersonal ? 1 : 0); 
      setSelected(p.selected ? 1 : 0)
      setFechaInicio(startDateNoOffset);
      setFechaProrroga(endDateNoOffset);
      setLogo(p.logo);
      // setChosenProgramId(p.program?.id);
      // setPrograms(allPrograms);
      setChosenPropuestaId(p.propuesta?.id)
      setPropuestas(allPropuestas)
      setConvocatorias(allConvocatorias)
      setChosenConvocatoriaId(p.convocatoria?.id)
      setAmbitos(allAmbitos);
      setChosenAmbitos(p.ambitos);
   setFinanciadora(allFinanciadoras);
   setChosenFinanciadoraId(p.financiadoras);
      setEntidadesParticipantes(allEntidadesParticipantes);
      setChosenEntidadesParticipantes(p.entidadesParticipantes);
      let investigators = await getAll(INVESTIGATORS, source);
      if (isMounted.current) {
        setIpsDisplay(p, investigators);
        setParticipantsDisplay(p, investigators);
        setAllowedEdit(true);
      }
    };

    const setIpsDisplay = async ({ staffProjects }, investigators) => {
      const { ips, participants } = separateRoles(staffProjects);
      setChosenIps(ips);
     
      
      //get unassigned investigators by comparing with chosenIps
      let rawIps = uniqueUsers(investigators, ips);
      let unassignedIps = uniqueUsers(rawIps, participants);    
      setIps(cleanUsers(unassignedIps));
    };

    const setParticipantsDisplay = async ({ staffProjects }, investigators) => {
      const { ips, participants } = separateRoles(staffProjects);
      setChosenParticipants(participants);

      //get unassigned investigators by comparing with participants
      let rawInvs = uniqueUsers(investigators, participants);
      let unassignedInvs = uniqueUsers(rawInvs, ips);

      setParticipants(cleanUsers(unassignedInvs));
    };

   

    // HANDLE INVESTIGATORS
    const addInvestigator = (ip, investigator) => {
      ip = JSON.parse(ip);

      investigator === "IP"
        ? //add chosenIp
          setChosenIps((state) =>
            produce(state, (drafState) => {
              drafState.push(ip);
            })
          )
        : //add chosenParticipant
          setChosenParticipants((state) =>
            produce(state, (drafState) => {
              drafState.push(ip);
            })
          );
  
     
      //remove ip from list
      setIps((state) =>
        produce(state, (drafState) => drafState.filter(({ id }) => id !== ip.id))
      );

      //remove participant from list
      setParticipants((state) =>
        produce(state, (drafState) => drafState.filter(({ id }) => id !== ip.id))
      );
    };

    const removeInvestigator = (ip, investigator) => {
      if (!allowedEdit) return;
      investigator === "IP"
        ? // remove chosenIp
          setChosenIps((state) =>
            produce(state, (drafState) =>
              drafState.filter(({ id }) => id !== ip.id)
            )
          )
        : // remove chosenParticipan
          setChosenParticipants((state) =>
            produce(state, (drafState) =>
              drafState.filter(({ id }) => id !== ip.id)
            )
          );

      // add ip to list
      setIps((state) =>
        produce(state, (drafState) => {
          drafState.push(ip);
        })
      );

      // add participant to list
      setParticipants((state) =>
        produce(state, (drafState) => {
          drafState.push(ip);
        })
      );
    };

    // HANDLE AMBITOS, ENTIDADES PARTICIPANTES Y COORDINADORAS
    const addItem = (item, type) => {
      item = JSON.parse(item);
      if (type === "ambitos") {
        setChosenAmbitos((state) =>
          produce(state, (draftState) => {
            draftState.push(item);
          })
        );
        setAmbitos((state) =>
          produce(state, (draftState) =>
            draftState.filter(({ id }) => id !== item.id)
          )
        );
      } else if (type === "entidadesParticipantes") {
        setChosenEntidadesParticipantes((state) =>
          produce(state, (draftState) => {
            draftState.push(item);
          })
        );
        setEntidadesParticipantes((state) =>
          produce(state, (draftState) =>
            draftState.filter(({ id }) => id !== item.id)
          )
        );
      } else if (type === "financiadoras") {
        setChosenFinanciadoraId((state) =>
          produce(state, (draftState) => {
            draftState.push(item);
          })
        );
        setFinanciadora((state) =>
          produce(state, (draftState) =>
            draftState.filter(({ id }) => id !== item.id)
          )
        );
      }
    };

    const removeItem = (item, type) => {
      if (!allowedEdit) return;
      if (type === "ambitos") {
        setChosenAmbitos((state) =>
          produce(state, (draftState) =>
            draftState.filter(({ id }) => id !== item.id)
          )
        );
        setAmbitos((state) =>
          produce(state, (draftState) => {
            draftState.push(item);
          })
        );
      } else if (type === "entidadesParticipantes") {
        setChosenEntidadesParticipantes((state) =>
          produce(state, (draftState) =>
            draftState.filter(({ id }) => id !== item.id)
          )
        );
        setEntidadesParticipantes((state) =>
          produce(state, (draftState) => {
            draftState.push(item);
          })
        );
      } else if (type === "financiadoras") {
        setChosenFinanciadoraId((state) =>
          produce(state, (draftState) =>
            draftState.filter(({ id }) => id !== item.id)
          )
        );
        setFinanciadora((state) =>
          produce(state, (draftState) => {
            draftState.push(item);
          })
        );
      }
    };

    const handleSubmit = () => {
      const project = build();           
      const notValid = validate(project);
      if (notValid) {
        setMessage(notValid);
        setTimeout(() => setMessage(""), 4000);
        return;
      }
      let question = isCreate ? "crear un" : "editar este";
      Swal.fire({
        icon: "question",
        text: `¿Quieres ${question} proyecto?`,
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then(({ isConfirmed }) => isConfirmed && handleConfirmation(project));
    };

    const handleConfirmation = (project) => {
      let createOrUpdate = isCreate
        ? create(PROJECTS, project, source)
        : update(PROJECTS, id, project, source);
      createOrUpdate
        .then(async ({ id: projectId }) => {
          const investigatorProjects = buildInvestigatorProject(
            chosenParticipants,
            chosenIps,
            projectId
          );
          await create(
            `${investigatorPROJECT}/${projectId}`,
            investigatorProjects,
            source
          );
          console.log(investigatorProjects, 'inv');
          
          let createOrUpdateText = isCreate ? "creado" : "editado";
          Swal.fire({
            icon: "success",
            text: `Proyecto ${createOrUpdateText} correctamente.`,
          });
          if (typeof logo !== "string") {
            const formData = new FormData();
            formData.append("image", logo);
            await saveFile(PROJECTS, projectId, "logo", formData, source);
          }
          history.push(`${ROUTES.Projects.all}/${projectId}`);
          isMounted.current && setIsCreate(false);
        })
        .catch(() => Swal.fire({ icon: "error", text: SwalError }));
    };

    const build = () => {
      const project = {
        tituloEs,
        tituloEn,
        tituloVa,
        fechaInicio: moment(fechaInicio).format("YYYY-MM-DD"),
        fechaProrroga: moment(fechaProrroga).format("YYYY-MM-DD"),
        resumenEs,
        resumenEn,
        resumenVa,
        acronimo,
        mostrarWeb,
        estado,
        gestionadoPor,
        tipo,
        referenciaInterna,
        referenciaOficial,
        investigadorParticipanteExterno,
        observaciones,
        ambitoIds: chosenAmbitos.map((ambito) => ambito.id),
        financiadoraIds: chosenFinanciadoraId?.map((ec) => ec.id),
        entidadParticipanteIds: chosenEntidadesParticipantes.map((ep) => ep.id),
        propuestaId: +chosenPropuestaId,
        convocatoriaId: +chosenConvocatoriaId,
        // programId: +chosenProgramId,
      };
    

      project.produccionPersonal =
        produccionPersonal === 1 || produccionPersonal === "1" ? true : false;     
              project.selected =
                selected === 1 || selected === "1" ? true : false;  
      return project;
    };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Proyecto
        </button>
      );
    }
    //if is update && logged user included as IP
    return (
      <>
        <button className="baseBtn" onClick={handleSubmit}>
          Guardar cambios
        </button>
        <button
          className="smallBtn btn-danger ml-1"
          onClick={() => deleteIt(PROJECTS, id, ROUTES.Projects.all, source)}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </>
    );
  };

  return (
    <div className="centerPage">
      {(isAdmin || userRoleId === 3 || userRoleId === 2) && (
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Proyecto </h3>
              </div>
              <div>{editDeleteButtons()}</div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center text-danger">
              <span>{message}</span>
            </div>
          </div>
          <div className=" form-row mt-2 ">
            <div className="col-6 d-flex justify-content-center">
              <FileUploader handleFile={setLogo} image={logo} />
            </div>
            <div className="col-6  d-flex flex-column  ">
              <small>Título en español (acrónimo)*</small>
              <input
                type="text"
                className="form-control"
                placeholder="*Título español"
                value={tituloEs}
                onChange={({ target: { value } }) => setTituloEs(value)}
                disabled={!allowedEdit}
              />
              <small>Título en inglés (acrónimo)*</small>
              <input
                type="text"
                className="form-control"
                placeholder="Título inglés"
                maxLength="500"
                value={tituloEn}
                onChange={({ target: { value } }) => setTituloEn(value)}
                disabled={!allowedEdit}
              />
              <small>Título en valenciano (acrónimo)*</small>
              <input
                type="text"
                className="form-control"
                placeholder="Título valenciano"
                maxLength="500"
                value={tituloVa}
                onChange={({ target: { value } }) => setTituloVa(value)}
                disabled={!allowedEdit}
              />
            </div>
          </div>

          <div className="form-row mt-2">
            <div className="col">
              <span>Fecha de inicio</span>
              <DatePicker
                className="form-control input"
                placeholderText="*Inicio"
                selected={fechaInicio}
                onChange={(date) => setFechaInicio(date)}
                dateFormat="dd MMMM, yyyy"
                isClearable={allowedEdit}
                locale="es"
                disabled={!allowedEdit}
              />
            </div>
            <div className="col">
              <span>Fecha de prórroga</span>
              <DatePicker
                className="form-control input"
                placeholderText="*Finalización"
                selected={fechaProrroga}
                onChange={(date) => setFechaProrroga(date)}
                dateFormat="dd MMMM, yyyy"
                isClearable={allowedEdit}
                locale="es"
                disabled={!allowedEdit}
              />
            </div>
            <div className="col">
              <span>Acrónimo</span>
              <input
                type="text"
                className="form-control"
                placeholder="Acrónimo"
                value={acronimo}
                onChange={({ target: { value } }) => setAcronimo(value)}
                disabled={!allowedEdit}
              />
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="col">
              <span>Destacado?</span>
              <select
                className="form-control input"
                value={selected}
                onChange={({ target: { value } }) => {
                  setSelected(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value={0}>No</option>
                <option value={1}>Si</option>
              </select>
            </div>
            <div className="col">
              <span>Referencia Oficial</span>
              <input
                type="text"
                className="form-control"
                placeholder="Referencia oficial"
                value={referenciaOficial}
                onChange={({ target: { value } }) =>
                  setReferenciaOficial(value)
                }
                disabled={!allowedEdit}
              />
            </div>
            <div className="col">
              <span>Referencia Interna</span>
              <input
                type="text"
                className="form-control"
                placeholder="Referencia interna"
                value={referenciaInterna}
                onChange={({ target: { value } }) =>
                  setReferenciaInterna(value)
                }
                disabled={!allowedEdit}
              />
            </div>
          </div>
          <div className="form-row mt-4">
            {/* Ámbitos */}
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) => addItem(value, "ambitos")}
                disabled={!allowedEdit}
              >
                <option value={""}>Seleccionar Ámbito</option>
                {ambitos?.map((ambit) => (
                  <option key={ambit.id} value={JSON.stringify(ambit)}>
                    {ambit.tituloEs}
                  </option>
                ))}
              </select>
              {chosenAmbitos?.map((ambit) => (
                <span
                  key={ambit.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3"
                  onClick={() => removeItem(ambit, "ambitos")}
                >
                  {ambit.tituloEs} X
                </span>
              ))}
            </div>
            {/* Entidades Coordinadoras */}
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addItem(value, "financiadoras")
                }
                disabled={!allowedEdit}
              >
                <option value={""}>Seleccionar Entidad Financiadora</option>
                {financiadora?.map((coordinadora) => (
                  <option
                    key={coordinadora.id}
                    value={JSON.stringify(coordinadora)}
                  >
                    {coordinadora.nombre}
                  </option>
                ))}
              </select>
              {chosenFinanciadoraId?.map((coordinadora) => (
                <span
                  key={coordinadora.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3"
                  onClick={() =>
                    removeItem(coordinadora, "financiadoras")
                  }
                >
                  {coordinadora.nombre} X
                </span>
              ))}
            </div>
            {/* Entidades Participantes */}
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addItem(value, "entidadesParticipantes")
                }
                disabled={!allowedEdit}
              >
                <option value={""}>Seleccionar Entidad Participante</option>
                {entidadesParticipantes?.map((participante) => (
                  <option
                    key={participante.id}
                    value={JSON.stringify(participante)}
                  >
                    {participante.nombre}
                  </option>
                ))}
              </select>
              {chosenEntidadesParticipantes?.map((participante) => (
                <span
                  key={participante.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3"
                  onClick={() =>
                    removeItem(participante, "entidadesParticipantes")
                  }
                >
                  {participante.nombre} X
                </span>
              ))}
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="col">
              <span>Investigador participante externo</span>
              <input
                type="text"
                className="form-control"
                placeholder="Investigador participante externo"
                value={investigadorParticipanteExterno}
                onChange={({ target: { value } }) =>
                  setInvestigadorParticipanteExterno(value)
                }
                disabled={!allowedEdit}
              />
            </div>
            <div className="col">
              <span>Producción personal?</span>
              <select
                className="form-control input"
                value={produccionPersonal}
                onChange={({ target: { value } }) => {
                  setProduccionPersonal(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value={0}>No</option>
                <option value={1}>Si</option>
              </select>
            </div>
            <div className="col">
              <span>Observaciones</span>
              <input
                type="text"
                className="form-control"
                placeholder="Observaciones"
                value={observaciones}
                onChange={({ target: { value } }) => setObservaciones(value)}
                disabled={!allowedEdit}
              />
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addInvestigator(value, "IP")
                }
                disabled={!allowedEdit}
              >
                <option value={""}>Investigadores principales</option>
                {ips?.map((i) => (
                  <option key={i.id} value={JSON.stringify(i)}>
                    {`${i.apellidos} , ${i.nombre}`}
                  </option>
                ))}
              </select>
              {chosenIps?.map((ip) => (
                <span
                  key={ip.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3  "
                  onClick={() => removeInvestigator(ip, "IP")}
                >
                  {`${ip.nombre} ${ip.apellidos}`} X
                </span>
              ))}
            </div>
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addInvestigator(value, "PARTICIPANT")
                }
                disabled={!allowedEdit}
              >
                <option value={""}>Investigadores participantes</option>
                {participants?.map((i) => (
                  <option key={i.id} value={JSON.stringify(i)}>
                    {`${i.apellidos} , ${i.nombre}`}
                  </option>
                ))}
              </select>
              {chosenParticipants?.map((participant) => (
                <span
                  key={participant.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3  "
                  onClick={() => removeInvestigator(participant, "PARTICIPANT")}
                >
                  {`${participant.nombre} ${participant.apellidos} `}X
                </span>
              ))}
            </div>
          </div>

          <div className="form-row mt-4">
            {/* <div className="col-6">
              <small>Seleccionar Programa*</small>
              <select
                className="form-control input"
                value={chosenProgramId}
                onChange={({ target: { value } }) => {
                  setChosenProgramId(value);
                }}
              >
                <option>Programa</option>
                {programs?.map(({ id, nameEs }) => (
                  <option key={id} value={id}>
                    {nameEs}
                  </option>
                ))}
              </select>
            </div> */}
            <div className="col-6">
              <small>Seleccionar Propuesta</small>
              <select
                className="form-control input"
                value={chosenPropuestaId}
                onChange={({ target: { value } }) => {
                  setChosenPropuestaId(value);
                }}
              >
                <option>Propuesta</option>
                {propuestas?.map(({ id, acronimo }) => (
                  <option key={id} value={id}>
                    {acronimo}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6">
              <small>Seleccionar Convocatoria</small>
              <select
                className="form-control input"
                value={chosenConvocatoriaId}
                onChange={({ target: { value } }) => {
                  setChosenConvocatoriaId(value);
                }}
              >
                <option>Convocatoria</option>
                {convocatorias?.map(({ id, nombreSubconvocatoria }) => (
                  <option key={id} value={id}>
                    {nombreSubconvocatoria}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-row mt-4">
            {" "}
            <div className="col-6">
              <small>Mostrar web?</small>
              <select
                className="form-control input"
                value={mostrarWeb}
                onChange={({ target: { value } }) => {
                  setMostrarWeb(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value="Si">Sí</option>
                <option value="No">No</option>
              </select>
            </div>
            <div className="col-6">
              <small>Estado</small>
              <select
                className="form-control input"
                value={estado}
                onChange={({ target: { value } }) => {
                  setEstado(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value="En_curso">En Curso</option>
                <option value="Cerrado">Cerrado </option>
              </select>
            </div>
          </div>
          <div className="form-row mt-4">
            {" "}
            <div className="col-6">
              <small>Gestionado por?</small>
              <select
                className="form-control input"
                value={gestionadoPor}
                onChange={({ target: { value } }) => {
                  setGestionadoPor(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value="UPV">UPV</option>
                <option value="CSIC">CSIC</option>
                <option value="Otros">Otros</option>
              </select>
            </div>
            <div className="col-6">
              <small>Tipo</small>
              <select
                className="form-control input"
                value={tipo}
                onChange={({ target: { value } }) => {
                  setTipo(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value="Accion_dinamizadora_I+D">
                  Acción dinamizadora I+D
                </option>
                <option value="Proyecto_I+D">Proyecto I+D </option>
                <option value="Grupos_I+D">Grupos I+D</option>
                <option value="Proyecto_UE">Proyecto UE </option>
                <option value="Acciones_complementarias">
                  Acciones complementarias
                </option>
                <option value="Proyecto_intramural_CSIC">
                  Proyecto intramural CSIC{" "}
                </option>
                <option value="Ayudas_a_Organizacion_Congresos">
                  Ayudas a Organización Congresos
                </option>
                <option value="Acciones_integradas">
                  Acciones integradas{" "}
                </option>
                <option value="Proyecto_nacional">Proyecto nacional</option>
                <option value="Otros">Otros </option>
                <option value="Otras_ayudas">Otras ayudas</option>
              </select>
            </div>
          </div>

          {(isCreate || allowedEdit) && (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Texto en español</small>
                  <CKEditor
                    initData={resumenEs}
                    config={editorConfig}
                    onChange={({ editor }) => setResumenEs(editor.getData())}
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Texto en inglés</small>
                  <CKEditor
                    initData={resumenEn}
                    config={editorConfig}
                    onChange={({ editor }) => setResumenEn(editor.getData())}
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Texto en valenciano</small>
                  <CKEditor
                    initData={resumenVa}
                    config={editorConfig}
                    onChange={({ editor }) => setResumenVa(editor.getData())}
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
